/**
 * 号码包提取页面
 */
export default {
  dbl_extraction_title: "号码包提取",
  dbl_extraction_data_source_status: "数据源情况",
  dbl_extraction_filter_conditions: "过滤条件",
  dbl_extraction_extract_field: "提取字段",
  dbl_extraction_extract_field_placeholder: "请选择提取字段",
  dbl_extraction_extract_field_info: "号码包提取对象只能为敏感字段。",
  dbl_extraction_package_type: "包类型",
  dbl_extraction_static_package: "静态包",
  dbl_extraction_updated_daily: "每天更新",
  dbl_extraction_package_name: "包名称",
  dbl_extraction_package_name_placeholder: "请输入包名称",
  dbl_extraction_package_note: "包备注(选填)",
  dbl_extraction_package_note_placeholder: "请输入包备注",
  dbl_extraction_save_success: "保存{name}成功",
  dbl_extraction_add_package: "新增号码包",
};